<div class="app-header">
  <div class="logo">
    <a href="http://www.teamfunded.com/" target="_blank">
      <img src="/assets/logo.png">
    </a>
  </div>
</div>